import { ExternalUploaderPollHandler } from '@ff-os/pdp-shared-redux/apis/external-upload/externalUploaderPoller';
import { actions as inputActions } from '@ff-scene-plugins/gift-redux/slices/inputsSlice';
import { GiftPdpStore } from '@ff-scene-plugins/gift-redux/store';
import { GiftExternalUploadPayload } from '@ff-scene-plugins/gift-redux/types/GiftExternalUploader';

export const createExternalUploadPollListener = (
    store: GiftPdpStore
): ExternalUploaderPollHandler<GiftExternalUploadPayload> => {
  return (assets) => {
      store.dispatch(inputActions.addExternalUploads(assets));
  };
};